import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./assets/tailwind.scss";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "./assets/tailwind.scss";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";

library.add(fas);
library.add(fab);

createApp(App)
  .use(store)
  .use(router)
  .use(Toast, {})
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
